import React from "react";
import { useState, useEffect } from "react";
import "./manageprintingpress.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

function Manageprintingpress() {
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedValues, setEditedValues] = useState({});

  const [listO, setlistO] = useState([]);

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getPress").then((response) => {
      setlistO(response.data);
      setFilteredUsers(response.data);
    });
  }, []);

  const handleDelete = async (id) => {
    const shouldDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (shouldDelete) {
      try {
        await Axios.delete(
          `https://nodei.ssccglpinnacle.com/deletePress/${id}`
        );
      } catch (error) {
        console.error(error);
      }
      window.location.reload();
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditedValues(listO[index]);
  };

  const handleInputChange = (e) => {
    setEditedValues({ ...editedValues, [e.target.name]: e.target.value });
  };

  console.log(editedValues);
  const handleSave = async () => {
    try {
      await Axios.put(
        `https://nodei.ssccglpinnacle.com/editPress/${editedValues._id}`,
        editedValues
      );

      setEditingIndex(-1);
      setEditedValues({});
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="managepringtingpress">
      <h5 style={{ textAlign: "center" }}>Manage Printing Press</h5>
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          <thead style={{ backgroundColor: "#f2f2f2" }}>
            <tr>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "60px",
                }}
              >
                Sr.No.
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "120px",
                }}
              >
                Press Name
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "140px",
                }}
              >
                Contact Person
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "110px",
                }}
              >
                Mobile
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "110px",
                }}
              >
                Whatsapp
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "200px",
                }}
              >
                Address
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "150px",
                }}
              >
                Aadhar
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "130px",
                }}
              >
                GST
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "130px",
                }}
              >
                Pan Card
              </th>
              <th
                style={{
                  padding: "6px",
                  border: "1px solid #ddd",
                  width: "150px",
                }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((usr, index) => {
              const isEditing = editingIndex === index;
              return (
                <tr key={index}>
                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {index + 1}
                  </td>

                  <td
                    style={{
                      padding: "6px",
                      border: "1px solid #ddd",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    {isEditing ? (
                      <input
                        name="Pressname"
                        value={editedValues.Pressname || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.Pressname
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <input
                        name="Personname"
                        value={editedValues.Personname || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.Personname
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <input
                        name="mobno"
                        value={editedValues.mobno || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.mobno
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <input
                        name="whatsappno"
                        value={editedValues.whatsappno || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.whatsappno
                    )}
                  </td>

                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      maxWidth: "250px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={usr.address}
                  >
                    {isEditing ? (
                      <input
                        name="address"
                        value={editedValues.address || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.address
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <input
                        name="aadhar"
                        value={editedValues.aadhar || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.aadhar
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <input
                        name="gst"
                        value={editedValues.gst || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.gst
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <input
                        name="pancard"
                        value={editedValues.pancard || ""}
                        onChange={handleInputChange}
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    ) : (
                      usr.pancard
                    )}
                  </td>

                  <td style={{ padding: "6px", border: "1px solid #ddd" }}>
                    {isEditing ? (
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#007bff",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#007bff",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleEdit(index)}
                      >
                        Edit
                      </button>
                    )}
                    <button
                      style={{
                        marginLeft: "5px",
                        backgroundColor: "red",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDelete(usr._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Manageprintingpress;
